const enum SiteEnum {
  B2B = 'b2b',
  Deco = 'deco',
}

export default SiteEnum;
